
import {Component, OnInit, isDevMode} from '@angular/core';
import { shouldLog } from '../utils/logging';
import { MatCardModule } from '@angular/material/card';

@Component({
    imports: [MatCardModule],
    template: `
    <mat-card class="medium-card">
      <mat-card-title>Redeem referral</mat-card-title>
      <mat-card-content>
        <p class="text-muted">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua.
        </p>
        <p class="text-muted">
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
          dolore eu fugiat nulla pariatur.
        </p>
        <div class="actions mt-2">
          <button mat-flat-button type="button" color="primary">OK</button>
        </div>
      </mat-card-content>
    </mat-card>
  `
})
export default class RedeemReferralComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    const func = '[record.ngOnInit]';
    if (shouldLog()) {
      console.log(`${func}`);
    }
  }
}
